<template>
    <div class="box">
        <inner-table id="archiveCertificatesInfo" ref="archiveCertificatesInfo" :listviewurl="'rsgl.archiveCertificatesInfo.list'" :can-edit="canEdit" :can-delete="canEdit" :link-prop-name="'archivesId'" />
    </div>
</template>

<script>
const moment = require('moment')
export default {
    components: {
    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            moduleInfoCertificate: {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/xsgl/archiveCertificatesInfo/form.html', 'addNewUrl': 'xsgl/rsglArchiveCertificatesInfo/addNew', 'insertUrl': 'xsgl/rsglArchiveCertificatesInfo/insert', 'getByIdUrl': 'xsgl/rsglArchiveCertificatesInfo/getById', 'updateUrl': 'xsgl/rsglArchiveCertificatesInfo/update', 'delUrl': 'xsgl/rsglArchiveCertificatesInfo/delete', 'listDataUrl': 'xsgl/rsglArchiveCertificatesInfo/listdata', 'winWidth': 1000, 'winHeight': 600, 'moduleCode': 'archiveCertificatesInfo', 'openViewType': '0', 'listAdvSearchAllFields': 0, 'listAdvSearchExpandPanel': 0},
            formTitle: '相关学历及职业技能证书'
        }
    },
    computed: {},
    watch: {

    },
    created: function() {
        let formurl = this.moduleInfoCertificate.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
    },
    mounted: function() {
    },
    methods: {
        // addObject2(){
        //     this.$bus.emit('openBusiform',this.moduleInfoCertificate,null,1)
        // },
        // // 内嵌子表-子表单提交前回调
        onInnerBasicFormBeforeSubmit($scope, vo, defer) {
            vo.status = vo.status ? vo.status : 1
            defer.resolve(true)
        },
        // 内嵌子表-加载数据后回调
        onInnerTableListDataLoaded($scope, pageInfo) {
            pageInfo.list.forEach(v => {
                v.certificatesDate = v.certificatesDate ? moment(v.certificatesDate).format('YYYY-MM-DD') : ''
                v.expiredDate = v.expiredDate ? moment(v.expiredDate).format('YYYY-MM-DD') : ''
            })
        }
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #dee2e6;
}
</style>

